import { createAsyncThunk } from "@reduxjs/toolkit";

export const startProcedure = createAsyncThunk<any, any>(
    '[ BONS ] Start Procedure',
    ({ planningId, fraisAutoroute, observation, immatriculation }, thunk: any) => {
        //console.log("START PROCEDURE FROM ASYNC THUNK");
        //console.log(fraisAutoroute, observation);
        return thunk.extra.bonService.startProcedure(planningId, { fraisAutoroute, observation, immatriculation });
    }
)

export const updateProcedureObservationClient = createAsyncThunk<any, any>(
    '[ BONS ] Update Procedure client observaton',
    ({  planningId, observation }, thunk: any) => {
        //console.log("START PROCEDURE FROM ASYNC THUNK");
        //console.log(fraisAutoroute, observation);
        return thunk.extra.bonService.updateProcedureObservationClient(planningId, {  observation });
    }
)